import IconicTag from './iconic-tag'
export default IconicTag
